<template>
    <div class="errorPage">
        <h1 class="mb-8">
            {{$t("forbiddenPage")}}
        </h1>
        <v-btn depressed color="primary" :to="{name:'Home'}">Retour a l'accueil</v-btn>
    </div>
</template>
<script>
export default {
    name:"Error403",
    created() {
        this.$store.dispatch('base/SET_SUB_MENU', []);
        this.$store.dispatch('base/SET_HEADER_ACTIONS', {});
    },
}
</script>
<style lang="scss">
    .errorPage {
        height:100%;
        display:flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>